import { useState } from 'react';
import { t } from 'utilities/TranslationUtils';

// components
import { RadioGroup, Radio } from '@trackman/web-shared-components';

// types
import { AppButton } from 'components/form';

type RadioFilterProps = {
  filter: { options: any[]; type: string; radioProps?: any; label?: string };
  onApply: (value?: any) => void;
};

export const RadioFilter = ({ filter, onApply }: RadioFilterProps) => {
  const [value, setValue] = useState<string | number >('');

  return (
    <div className='data-table-filter-content gap-10px'>
      <RadioGroup
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onKeyDown={(e) => e.key === 'Enter' && onApply(value)}
        value={value ?? ''}
        style={{gap: '0px'}}
      >
        {filter.options.map((c, i) => (
          <Radio
            className={`radio-border ${c.value === value ? 'radio-border-checked' : ''}`}
            data-test={`radio-${c.label?.replace(/\s/g, '')}`}
            key={i}
            {...c}
            reversed='true'
            checked={c.value === value}
            margin="3px"
          />
        ))}
      </RadioGroup>

      <AppButton data-test='ApplyFilterSubmit' type='button' className='apply-button ' variant='primary' onClick={() => onApply(value)}>
        {t('common.apply')}
      </AppButton>
    </div>
  );
};

export default RadioFilter;
